import waypoint from 'waypoints/lib/noframework.waypoints'
import size from './size.js'

const mainMenuBar = () => {

  if (size.screenSize <= 1140) {

    const header = document.querySelector('.header')

    const waypoint = new Waypoint({
      element: document.querySelector('body'),
      handler: direction => {

        if (direction === 'up') {
          header.classList.remove('header--small')
        }

        else if (direction === 'down') {
          header.classList.add('header--small')
        }
      },
      offset: -1
    })
  } else {

  }
  window.addEventListener('DOMContentLoaded', function (e) {

    if (document.querySelector('#second-menu-wrapper') && document.querySelector('.second-menu__item--active')) {
      console.log('e', document.querySelector('#second-menu-wrapper').scrollLeft)
      const offset = document.querySelector('.second-menu__item--active').offsetLeft
      const width = document.querySelector('.second-menu__item--active').offsetWidth
      console.log(offset)
      console.log(offset + screen.width / 2)
      document.querySelector('#second-menu-wrapper').scrollLeft += offset - (screen.width / 2) + width / 2
    }

  })

}


export default mainMenuBar